<template>
    <div class="homepage-domov bg-white dark:bg-surface-card">
        <!--
            SSR-render the generic hero by default so the LCP image is discoverable in the
            initial HTML. After hydration we swap to the personalized hero for logged-in users.
            Wrapping both branches in <ClientOnly> previously left the SSR document empty,
            which delayed LCP and caused a ~0.8 CLS shift when the hero popped in on hydration.
        -->
        <component :is="personalizedHomepage" v-if="personalizedHomepage" />
        <HomepageDomovGeneric v-else />

        <!-- Common sections at the bottom -->
        <div class="bg-white dark:bg-surface-card">
            <ClientOnly>
                <EmailNewsletterBlock />
            </ClientOnly>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'
import { useApplicationStore } from '@/stores/application'
import HomepageDomovGeneric from '@/components/homepage/domov/HomepageDomovGeneric.vue'

definePageMeta({
    layout: 'default'
})

useHeadMeta()

useHead({
    link: [
        {
            rel: 'preload',
            as: 'image',
            href: '/images/sprout_transparent.webp',
            fetchpriority: 'high'
        }
    ]
})

const store = useApplicationStore()

// Only logged-in users get the personalized homepage, so anonymous visitors never download it. The
// generic page stays until the chunk has arrived, instead of an empty page while it loads.
const personalizedHomepage = shallowRef<Component | null>(null)

onMounted(async () => {
    if (!store.APPLICATION_LOGGED_IN) return

    const module = await import('@/components/homepage/domov/HomepageDomovPersonalizedNew.vue')
    personalizedHomepage.value = module.default
})
</script>
